module.exports = __webpack_public_path__ + "portal-static/img/1首页--1实验用房使用排行_44.8cbfc2dd.jpg";